'use strict';
const toggler = (() => {
    const _o = {
        selectors: {
            trigger: '[data-toggle]',
            target: '[data-toggle-container]',
            wrapper: '[data-toggle-wrapper]',
            inner: '[data-toggle-inner]',
            text: '[data-toggle-text]',
            minHeight: '[data-min-height]'
        },
        classes: {
            animation: 'toggle-animation',
            show: 'show',
            toggleTrigger: 'active'
        }
    };

    let activeElements = {}, elements = [];

    const init = () => {
        document.querySelectorAll( _o.selectors.trigger ).forEach((el) => initEvents( el ));
    };

    const initEvents = ( trigger ) => {
        let targetSelector = trigger.dataset.toggle;
        targetSelector = targetSelector ? targetSelector : trigger.hash;
        targetSelector = targetSelector.replace('#', '');
        const target = document.getElementById(targetSelector);
        const minHeight = trigger.dataset.minHeight;

        const element = {
            trigger: trigger,
            targetSelector: targetSelector,
            target: target,
            wrapper : target.closest(_o.selectors.wrapper),
            inner : target.querySelector(_o.selectors.inner),
            textContainer: trigger.querySelector(_o.selectors.text),
            status: true,
            active: false,
            closeActive: trigger.dataset.closeActive !== undefined,
            minHeight: minHeight
        };

        elements.push(element);

        if(minHeight) target.style.height = minHeight + 'px';

        trigger.addEventListener( 'click', (e) => onClick(e, element));
        //setAriaTrigger(element);

        target.addEventListener('webkitTransitionEnd', (e) => onAnimationEnd( e, element ) );
        target.addEventListener('transitionend', (e) => onAnimationEnd( e, element ) );
    };

    const setAriaTrigger = ( el ) => {
        el.trigger.setAttribute('aria-expanded', el.trigger.classList.contains(_o.classes.toggleTrigger));
        el.trigger.setAttribute('aria-controls', el.targetSelector);
    };

    const onClick = ( e, el ) => {
        e.preventDefault();

        //prevent toggling when transition in progress
        if(!el.status)
            return;

        el.status = false;

        //set if element is already opened
        el.active = !el.active;

        if(el.active)
            activeElements[el.targetSelector] = el;

        if(el.closeActive && el.active)
            closeActiveElements(el);

        processTrigger( el );
        processTarget( el );
    };

    const processTrigger = ( el ) => {
        el.trigger.classList.toggle(_o.classes.toggleTrigger);
        el.trigger.setAttribute('aria-expanded', !JSON.parse(el.trigger.getAttribute('aria-expanded')));

        if(!el.textContainer)
            return;

        el.toggleText = el.toggleText ? el.toggleText : el.textContainer.dataset.toggleText;
        el.baseText = el.baseText ? el.baseText : el.textContainer.innerText;

        el.textContainer.innerText = (el.active) ? el.toggleText : el.baseText;
    };

    const processTarget = ( el ) => {

        if(el.target.classList.contains(_o.classes.show)) {
            //close
            el.target.style.height = el.inner.offsetHeight + 'px';

            setTimeout(() => {
                el.target.style.height = (el.minHeight ? el.minHeight : '0') + 'px';
                el.target.classList.add(_o.classes.animation);
                if(el.wrapper) el.wrapper.classList.remove(_o.classes.toggleTrigger);
            }, 0);
        } else {
            //open
            el.target.classList.add(_o.classes.animation);
            if(el.wrapper) el.wrapper.classList.add(_o.classes.toggleTrigger);
            el.target.style.height = el.inner.offsetHeight + 'px';
        }
    };

    const closeActiveElements = ( currentEl ) => {
        Object.entries(activeElements).forEach(([key, element]) => {
            if(element.active && element !== currentEl)
                closeToggler(element);
        });
    };

    const closeToggler = (element) => {
        element.active = !element.active;
        delete activeElements[element.targetSelector];

        processTrigger( element );
        processTarget( element );
    };

    const onAnimationEnd = ( e, el ) => {
        if(e.propertyName !== 'height') return;

        el.target.classList.remove(_o.classes.animation);
        if(!el.minHeight) el.target.style = '';
        el.target.classList.contains(_o.classes.show) ? el.target.classList.remove(_o.classes.show) : el.target.classList.add(_o.classes.show);

        //100ms timeout - prevent bug when spam clicking in one trigger
        setTimeout(() => {
            el.status = true;
        }, 100);
    };

    return {
        init: init
    };
})();

export { toggler }
